<template>
  <new-role />
</template>

<script>
import NewRole from "@/components/3pl/Settings/RolesAndPrivileges/NewRole";
export default {
  components: {
    NewRole,
  },
};
</script>

<style></style>
